import { toCamelCase } from 'utils/stringUtils';
import { UtmInput, UtmOutput } from '../models';

export const parseUtmToApiSchema = (inputParams: UtmInput): UtmOutput =>
  Object.keys(inputParams).reduce(
    (acc, key) => ({
      ...acc,
      [`${toCamelCase(key)}`]: inputParams[key],
    }),
    {} as UtmOutput
  );
